import { createAsyncThunk } from '@reduxjs/toolkit'
import newsDetailAPI from '../../../apis/api/api-news-detail'

export const getNewsDetail = createAsyncThunk('/news/newsDetail', async (url: string) => {
  return await newsDetailAPI.getNewsDetail(url)
})
